'use client'

import LegalDocumentPdfButton from '@/components/legal/LegalDocumentPdfButton'
import LegalMarkdownView from '@/components/legal/LegalMarkdownView'
import { Box, Paper } from '@mui/material'

type Props = {
  title: string
  version: string
  slug: string
  markdown: string
}

export default function LegalDocumentPaper({ title, version, slug, markdown }: Props) {
  return (
    <Paper
      elevation={0}
      sx={{
        position: 'relative',
        p: { xs: 2.5, md: 4 },
        pt: { xs: 5.5, md: 4 },
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ position: 'absolute', top: 12, right: 12, zIndex: 1 }}>
        <LegalDocumentPdfButton title={title} version={version} markdown={markdown} slug={slug} />
      </Box>
      <LegalMarkdownView markdown={markdown} />
    </Paper>
  )
}
